import {until} from 'lit-html/directives/until';
import {
  jobStatusLabels,
  jobTypesLabels,
  jobStagesLabels,
  inviteResultLabels,
  generalLabels
} from '../i18n-labels';
import {jobStatuses, jobTypes, productLabels} from '../constants-enumerate';
import {UserJobs} from '../user-jobs';
import '../export-search-job';
import {repeat} from 'lit-html/directives/repeat';

const renderJobTypeHeading = (ctx, html, job) => {
  if (job.job_type === jobTypes.LICENSING) {
    const product = job.meta_data.aofl_product;
    return html`${productLabels[product]} ${until(jobTypesLabels[job.job_type])}`;
  }

  return html`${until(jobTypesLabels[job.job_type])}`;
};

const failed = (job, ctx, html) => html`
  <div class="alert slide-in alert-danger">
    <div>
      <h5 class="alert-heading">${renderJobTypeHeading(ctx, html, job)}</h5>
      <div tabIndex="0" class="cursor-pointer close" @keypress="${(e) => (e.key === 'Enter' || e.code === 'Space') ? ctx.dismiss(job.id): null}" @click="${(e) => ctx.dismiss(job.id)}">X</div>
      <p>${until(jobStagesLabels[job.job_type][job.stage])}</p>
      ${job.$endDateTime}
    </div>
  </div>
`;
const inProgress = (job, ctx, html) => html`
  <div class="alert slide-in alert-warning text-dark">
    <h5 class="alert-heading">${renderJobTypeHeading(ctx, html, job)} (${job.percentage}%)</h5>

    <p class="mb-0">${until(jobStatusLabels[job.status])} ${until(jobStagesLabels[job.job_type][job.stage])}</p>
    ${job.$startTime}
  </div>
`;

const done = (job, ctx, html) => html`
  <div class="alert flip-x alert-success">
    <div class="flip-x-text-reset">
      <h5 class="alert-heading">${renderJobTypeHeading(ctx, html, job)} (${job.percentage}%)</h5>
      <div tabIndex="0" class="cursor-pointer close" @keypress="${(e) => (e.key === 'Enter' || e.code === 'Space') ? ctx.dismiss(job.id): null}" @click="${(e) => ctx.dismiss(job.id)}">X</div>
      <p>${until(jobStatusLabels[job.status])} ${until(jobStagesLabels[job.job_type][job.stage])}</p>
      ${renderJobDoneInfo(ctx, html, job)}
      ${job.$endDateTime}
    </div>
  </div>
`;

const renderJobDoneInfo = (ctx, html, job) => {
  if (
    job.job_type === jobTypes.EXPORT_SEARCH ||
    job.job_type === jobTypes.INVITES_PRINT ||
    job.job_type === jobTypes.ROSTER_EXPORT ||
    job.job_type === jobTypes.GENERATE_QR ||
    job.job_type === jobTypes.DASHBOARD_CSV_EXPORT) {
    return html`<export-search-job tabIndex="0" class="btn btn-dark btn-block cursor-pointer" .job="${job}">${until(generalLabels.download)} <span class="ai ai-download"></span></export-search-job>`;
  }

  if (
    (
      job.job_type === jobTypes.INVITES
      ||
      job.job_type === jobTypes.TEACHER_INVITES
      ||
      job.job_type === jobTypes.ADMIN_INVITES
    )
    &&
    Object.keys(job.result).length > 0
  ) {
    const templates = [];
    if (Object.keys(job.result.invites_sent_by_product).length) {
      Object.keys(job.result.invites_sent_by_product).forEach((product) => {
        templates.push(html`<div>${until(inviteResultLabels.productInvitesSent(productLabels[product]))}: ${job.result.invites_sent_by_product[product]}</div>`);
      });
    } else {
      templates.push(html`<div>${until(inviteResultLabels.sent)}: ${job.result.invites_sent}</div>`);
    }

    if (job.result.users_already_active) {
      templates.push(html`<div>${until(inviteResultLabels.usersAlreadyActive)}: ${job.result.users_already_active}</div>`);
    }

    if (job.result.invalid_emails) {
      templates.push(html`<div>${until(inviteResultLabels.invalidEmails)}: ${job.result.invalid_emails}</div>`);
    }

    if (job.result.skipped > 0) {
      templates.push(html`<div>${until(inviteResultLabels.skipped)}: ${job.result.skipped}</div>`);
    }

    if (job.result.skipped_due_to_test_email > 0) {
      templates.push(html`<div>${until(inviteResultLabels.skipped_due_to_test_email)}: ${job.result.skipped_due_to_test_email}</div>`);
    }

    return html`${templates}`;
  }
};

const canceled = (job, ctx, html) => html`
  <div class="alert slide-in alert-dark canceled">
    <h5 class="alert-heading">${renderJobTypeHeading(ctx, html, job)}</h5>
    <div tabIndex="0" class="cursor-pointer close" @keypress="${(e) => (e.key === 'Enter' || e.code === 'Space') ? ctx.dismiss(job.id): null}" @click="${(e) => ctx.dismiss(job.id)}">X</div>
    <p class="mb-0">${until(jobStatusLabels[job.status])} ${until(jobStagesLabels[job.job_type][job.stage])}</p>
  </div>
`;

const getJobTemplate = (job, ctx, html) => {
  if (job.status === jobStatuses.FAILED) {
    return failed(job, ctx, html);
  } else if (job.status === jobStatuses.CANCELED) {
    return canceled(job, ctx, html);
  } else if (UserJobs.isDone(job)) {
    return done(job, ctx, html);
  }

  return inProgress(job, ctx, html);
};

export default (ctx, html) => html`
${repeat(ctx.jobs.slice(0, 5), (job) => job.id, (job) => getJobTemplate(job, ctx, html))}
`;
